import { get, startCase, uniqueId } from "lodash";
import {
  ILayoutSettings,
  PageSectionCategory,
} from "@/Apps/Pages/Sections/WebLayouts/types";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { BenefitLayouts } from "../types";

import theme from "../../theme";

import { style } from "./style";
import content from "./data.json";
import { getImagePlaceholder, ImagePlaceholderTypes } from "../../Placeholders";

import {
  default as Icon,
  IconTypes,
} from "@/Apps/Pages/WebComponents/v2/Icon";

const settings: ILayoutSettings = {
  label: BenefitLayouts.THIRTEEN,
  layout: BenefitLayouts.THIRTEEN,
  previewImage:
    "https://sandcastleassets.s3.amazonaws.com/blocks/benefits/Benefit13.png",
  loadFromExt: true,
  loadFromExtSettings: {
    pageId: "ckkx5he5q231g07808cui36sy",
    itemId: "8l7za7l6jwd",
  },
  default: {
    label: PageSectionCategory.BENEFIT,
    type: ComponentTypes.SECTION,
    bodyOnly: true,
    canHaveChildren: true,
    properties: {
      ...style.SECTION,
      ...style.SECTION_INNER,
    },
    children: [
      {
        type: ComponentTypes.HEADLINE,
        canHaveChildren: false,
        properties: {
          ...style.HEADLINE,
          ...get(content, "main_headline.style", {}),
        },
        html: get(content, "main_headline.html", "..."),
      },
      {
        type: ComponentTypes.COLUMNS,
        canHaveChildren: false,
        properties: {
          width: "100%",
          marginTop: 50,
        },
        children: [
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((4 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.CONTAINER,
                canHaveChildren: true,
                properties: {
                  padding: 20,
                },
                children: [
                  {
                    type: ComponentTypes.ICON,
                    canHaveChildren: false,
                    properties: style.ICON,
                    iconType: IconTypes.Email,
                  },
                  {
                    type: ComponentTypes.HEADLINE,
                    canHaveChildren: false,
                    properties: {
                      ...style.ITEM_HEADLINE,
                      ...get(content, "main_headline.style", {}),
                    },
                    html: "Proven Strategy",
                  },
                  {
                    type: ComponentTypes.TEXT,
                    canHaveChildren: false,
                    properties: {
                      ...style.TEXT,
                      ...get(content, "sub_headline.style", {}),
                    },
                    html: get(content, "sub_headline.html", "..."),
                  },
                ],
              },
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((4 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.CONTAINER,
                canHaveChildren: true,
                properties: {
                  padding: 20,
                },
                children: [
                  {
                    type: ComponentTypes.ICON,
                    canHaveChildren: false,
                    properties: style.ICON,
                    iconType: IconTypes.Email,
                  },
                  {
                    type: ComponentTypes.HEADLINE,
                    canHaveChildren: false,
                    properties: {
                      ...style.ITEM_HEADLINE,
                      ...get(content, "main_headline.style", {}),
                    },
                    html: "Proven Strategy",
                  },
                  {
                    type: ComponentTypes.TEXT,
                    canHaveChildren: false,
                    properties: {
                      ...style.TEXT,
                      ...get(content, "sub_headline.style", {}),
                    },
                    html: get(content, "sub_headline.html", "..."),
                  },
                ],
              },
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((4 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.CONTAINER,
                canHaveChildren: true,
                properties: {
                  padding: 20,
                },
                children: [
                  {
                    type: ComponentTypes.ICON,
                    canHaveChildren: false,
                    properties: style.ICON,
                    iconType: IconTypes.Email,
                  },
                  {
                    type: ComponentTypes.HEADLINE,
                    canHaveChildren: false,
                    properties: {
                      ...style.ITEM_HEADLINE,
                      ...get(content, "main_headline.style", {}),
                    },
                    html: "Proven Strategy",
                  },
                  {
                    type: ComponentTypes.TEXT,
                    canHaveChildren: false,
                    properties: {
                      ...style.TEXT,
                      ...get(content, "sub_headline.style", {}),
                    },
                    html: get(content, "sub_headline.html", "..."),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default settings;
